import React from 'react';
import {
  Box,
  Container,
  Text,
  Heading,
  VStack,
  HStack,
} from '@chakra-ui/react';
import { useParams, Navigate, useNavigate } from 'react-router-dom';
import { Icon } from 'src/components/atoms/Icon';
import { getBlogPostBySlug } from 'src/features/MP/utils/constants';
import MarkdownContent from 'src/features/MP/components/molecules/MarkdownContent';

const BlogPostPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();

  if (!slug) {
    return <Navigate to="/now" replace />;
  }

  const blogPost = getBlogPostBySlug(slug);

  if (!blogPost) {
    return <Navigate to="/now" replace />;
  }

  const handleBackClick = () => {
    navigate('/now');
  };

  return (
    <Box color="text.darkBlue.900" bg="white" position="relative">
      <Container py={{ base: 8, md: 16 }} maxW="container.lg">
        {/* Back button */}
        <Box
          onClick={handleBackClick}
          color="gray.600"
          fontSize="16px"
          fontWeight="medium"
          cursor="pointer"
          _hover={{ textDecoration: 'underline' }}
          display="flex"
          alignItems="center"
          gap={2}
          mb={8}>
          <Icon
            iconName="chevron-right"
            w={'18px'}
            h={'18px'}
            transform="rotate(180deg)"
          />
          Back to Now
        </Box>

        {/* Article header */}
        <VStack align="stretch" spacing={6} mb={12}>
          <HStack spacing={2} mb={4}>
            <Text fontSize="15px" color="gray.600" fontWeight="medium">
              By {blogPost.author}
            </Text>
            <Text fontSize="15px" color="gray.500">
              • {blogPost.date}
            </Text>
          </HStack>

          <Heading
            as="h1"
            fontSize={{ base: '32px', md: '48px' }}
            fontWeight="bold"
            color="text.darkBlue.900"
            lineHeight="1.2"
            fontFamily="marketingPage"
            textTransform="uppercase">
            {blogPost.title}
          </Heading>
        </VStack>

        {/* Article content */}
        {typeof blogPost.content === 'string' ? (
          <MarkdownContent content={blogPost.content} />
        ) : (
          React.createElement(blogPost.content)
        )}
      </Container>
    </Box>
  );
};

export default BlogPostPage;
